import { render, staticRenderFns } from "./CrudCourse.vue?vue&type=template&id=f9ffd12a&scoped=true&"
import script from "./CrudCourse.vue?vue&type=script&lang=js&"
export * from "./CrudCourse.vue?vue&type=script&lang=js&"
import style0 from "./CrudCourse.vue?vue&type=style&index=0&id=f9ffd12a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ffd12a",
  null
  
)

export default component.exports